import React from "react";
import { FiX, FiXCircle } from "react-icons/fi";
import "../../../views/app/productCategories/AddProductCategoryModal.scss";
import "./modals.scss";
import styles from "./ErrorModal.module.css";

interface ErrorModalProps {
  show: boolean;
  onHide: () => void;
  title: string;
  message: string;
  actionText?: string;
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  show,
  onHide,
  title,
  message,
  actionText = "OK",
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <div className={styles.headerContainer}>
            <FiXCircle size={24} color="#EC3237" />
            <h2>{title}</h2>
          </div>
          <FiX className="close-icon" onClick={onHide} />
        </div>
        <div className="modal-form">
          <p className={styles.message}>{message}</p>
          <button
            type="button"
            className={`submit-btn ${styles.errorButton}`}
            onClick={onHide}
          >
            {actionText}
          </button>
        </div>
      </div>
    </div>
  );
};
